import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfService } from '@leandredev/common_ng';

import { AppVersion } from './AppVersion';
import { LoginService } from './modules/login/services/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'r3-front-ui';

  protected timeoutId!: number;

  constructor(public router: Router, protected confService: ConfService, protected loginService: LoginService) {
    //
    console.info(`%c Version: ${AppVersion.appVersion}`, 'background:#ff0000;color:#FFFFFF;font-size:50px');
  }
  ngOnDestroy(): void {
    window.clearTimeout(this.timeoutId);
  }
  ngOnInit(): void {
    // TODO : decomenter lors de la mis een place du login corectement
    // this.activityWhatcher();
  }

  activityWhatcher(): void {
    window.clearTimeout(this.timeoutId);
    this.timeoutId = window.setTimeout(() => {
      this.closeConnection();
    }, 1800000);
  }

  protected closeConnection(): void {
    if (this.loginService.isSignedIn()) {
      this.loginService.signOut();
      this.router.navigate(['/']);
    }
  }
}
